import React, { FC, useState } from "react";
import { Image, Form, Input, Button } from "antd-mobile";
import logo from '../../assets/images/logo.svg';
import styles from "./login.module.scss";
import Container from '../../components/Container';
import { CONTAINER_STYLES } from '../../styles/constants';
import userIcon from '../../assets/images/username_icon.svg';
import lookpassicon from '../../assets/images/lookpassicon.svg';
import captchaIcon from '../../assets/images/captcha_icon.svg';
import { EyeInvisibleOutline, EyeOutline } from 'antd-mobile-icons';

const Login: FC = () => {
  const [formlogin] = Form.useForm();
  const [passWordvisible, setPassWordvisible] = useState(false);
  const [RepassWordvisible, setRePassWordvisible] = useState(false);

  const handleLogin = () => {
    console.log("登录");
  };

  return (
    <Container style={{
      backgroundImage: `url(${require("../../assets/images/login_bg.png")})`,
    }}>
      <Image src={logo} className="max-w-[200px] mt-[94px]" />
      <div className={CONTAINER_STYLES.formWrapper}>
        <Form
          name="login_form"
          form={formlogin}
          onFinish={handleLogin}
          initialValues={{ remember: true }}
          footer={
            <Button block type="submit" className={CONTAINER_STYLES.button} size="large">登录</Button>
          }
        >
          {/* 账号 */}
          <Form.Item
            name="username"
            rules={[
              { required: true, message: "请输入6-20位（数字、大小写英文）" },
              { min: 6, max: 20, message: "请输入6-20位（数字、大小写英文）" },
              {
                pattern: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{6,20}$/,
                message: "账户必须是6-20位的数字加字母组合",
              },
            ]}
            className={`${CONTAINER_STYLES.textCenter} ${styles.formItem}`}
          >
            <div className={CONTAINER_STYLES.inputContainer}>
              <Image src={userIcon} width={20} className={CONTAINER_STYLES.iconMargin} />
              <Input className="rounded-lg" placeholder="请输入用户名" />
            </div>
          </Form.Item>
          {/* 密码 */}
          <Form.Item
            name="password"
            rules={[
              { required: true, message: "请输入6-20位（数字、大小写英文）" },
              { min: 6, max: 20, message: "请输入6-20位（数字、大小写英文）" },
              {
                pattern: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{6,20}$/,
                message: "密码必须是6-20位的数字加字母组合",
              },
            ]}
            className={`${CONTAINER_STYLES.textCenter} ${styles.formItem}`}
          >
            <div className={CONTAINER_STYLES.inputContainer}>
              <Image src={lookpassicon} width={20} className={CONTAINER_STYLES.iconMargin} />
              <Input className="rounded-lg" placeholder="请输入密码" type={passWordvisible ? "text" : "password"} />
              <div className={styles.eye}>
                {!passWordvisible ? (
                  <EyeInvisibleOutline color="#fff" onClick={() => setPassWordvisible(true)} />
                ) : (
                  <EyeOutline color="#fff" onClick={() => setPassWordvisible(false)} />
                )}
              </div>
            </div>
          </Form.Item>
          {/*确认密码*/}
          <Form.Item
            name="rePassword"
            rules={[
              { required: true, message: "请确认密码" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(new Error("两次密码不一致"));
                  }
                },
              }),
            ]}
            className={`${CONTAINER_STYLES.textCenter} ${styles.formItem}`}
          >
            <div className={CONTAINER_STYLES.inputContainer}>
              <Image src={lookpassicon} width={20} className={CONTAINER_STYLES.iconMargin} />
              <Input className="rounded-lg " placeholder="请再次输入密码" type={RepassWordvisible ? "text" : "password"} />
               <div className={styles.eye}>
                 {!RepassWordvisible ? (
                   <EyeInvisibleOutline color="#fff" onClick={() => setRePassWordvisible(true)} />
                 ) : (
                   <EyeOutline color="#fff" onClick={() => setRePassWordvisible(false)} />
                 )}
               </div>
            </div>
          </Form.Item>
          {/* 昵称 */}
          <Form.Item
            name="nickname"
            rules={[{ required: true, message: "请输入昵称" }]}
            className={`${CONTAINER_STYLES.textCenter} ${styles.formItem}`}
          >
            <div className={CONTAINER_STYLES.inputContainer}>
              <Image src={userIcon} width={20} className={CONTAINER_STYLES.iconMargin} />
              <Input className="rounded-lg " placeholder="请输入昵称" />
            </div>
          </Form.Item>
          {/* 验证码*/}
          <Form.Item
            name="captcha"
            rules={[{ required: true, message: "请输入验证码" }]}
            className={`${CONTAINER_STYLES.textCenter} ${styles.formItem}`}
          >
            <div className={CONTAINER_STYLES.inputContainer}>
              <Image src={captchaIcon} width={20} className={CONTAINER_STYLES.iconMargin} />
              <Input className="rounded-lg " placeholder="请输入验证码" />
            </div>
          </Form.Item>

          {/* 代理邀请码*/}
          <Form.Item
            name="yanzhengma"
            className={`${CONTAINER_STYLES.textCenter} ${styles.formItem}`}
          >
            <div className={CONTAINER_STYLES.inputContainer}>
              <Image src={userIcon} width={20} className={CONTAINER_STYLES.iconMargin} />
              <Input
                className="rounded-lg "
                placeholder="请输入代理邀请码（非必填）"
              />
            </div>
          </Form.Item>
        </Form>
      </div>
    </Container>
  );
};

export default Login;
